import { useRef } from "react";
import { dateFormat } from "../../const/date";
import sanitizeHtml from "sanitize-html";
import ModalPop from "./ModalPop";
import menuOnClick from "../common/menuOnClick";

type BlogData = {
  data: {
    category: Array<string>;
    title: Array<string>;
    link: Array<string>;
    description: Array<string>;
    pubDate: Array<string>;
  }[];
};

const Blog = ({ data }: { data: BlogData[] | any[] }) => {
  const blog = ParseData({ data });

  const getTranslated = (key: string) => {
    const text = key || ""; //data json에서 호출
    const sanitizedText = sanitizeHtml(text, {
      allowedTags: ["br", "em", "span"], //허용할 태그 지정
    });
    return { __html: sanitizedText };
  };

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />

      <div
        id="blog"
        className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36"
      >
        <div className="max-w-[1200px] mx-auto">
          {/* Heading */}
          <div className="text-center">
            <p className="text-lg lg:text-xl">실제 작업은 어떤식으로 이루어지는 알 수 있나요?</p>
            <h2 className="mt-2 text-3xl md:text-4xl xl:text-5xl">
              <span className="font-light">바우하우스</span> <span className="text-[#26d000]">BLOG</span>&nbsp;
              <span className="text-[#F4791C]">작업사례</span>
            </h2>
          </div>
          {/* Card */}
          <div
            data-aos="fade-up"
            className="mt-8 grid grid-cols-1 items-center gap-10 rounded-3xl border-2 border-[#F4791C] px-6 py-6 md:mt-10 md:grid-cols-2 md:gap-6 md:px-7 md:py-7"
          >
            {/* Left: copy */}
            <div className="w-full text-center">
              <p className=" lg:text-xl">유품정리 의뢰를 하고싶은데</p>
              <p className="mt-4 lg:text-xl !leading-tight">
                어떤 절차로 작업이 이루어지는지,
                <br />
                제가 어떤것들을 준비해야하는지를 몰라
                <br />
                문의가 망설여집니다
              </p>
              <p className="mt-6 text-lg font-bold !leading-relaxed text-black lg:text-2xl 2xl:text-3xl">
                이러한 고민을
                <br />
                <span className="text-primary">한방에 해결</span>해드릴 수 있도록
                <br />
                직접 보여드리겠습니다
              </p>
            </div>

            {/* Right: overlapping photo collage */}
            <div className="relative mx-auto h-full w-full">
              <img src="/images/review.png" alt="바우하우스 블로그" />
            </div>
          </div>

          <div className="relative w-full h-fit max-w-[1400px] min-h-36 mx-auto grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-5 text-black mt-8">
            {blog.map((v, i) => (
              <div
                data-aos="fade-up"
                key={i}
                onClick={() => window.open(v.link[0])}
                className={i > 7 ? "hidden lg:block relative w-full h-full" : "relative w-full h-full"}
              >
                <div className="relative w-full h-full rounded-xl grid bg-white p-2 md:p-3 text-left border cursor-pointer transition-all duration-300 overflow-hidden">
                  <p
                    className={`relative w-full text-primary whitespace-nowrap overflow-hidden overflow-ellipsis lg:text-lg h-fit mb-1.5 lg:mb-3`}
                  >
                    {v.title[0]}
                  </p>
                  <small
                    className={`relative w-full whitespace-nowrap md:whitespace-normal overflow-hidden overflow-ellipsis h-fit md:h-9 my-2 lg:my-0 break-words md:line-clamp-2 text-sm opacity-60`}
                    dangerouslySetInnerHTML={getTranslated(v.description[0])}
                    // dangerouslySetInnerHTML={{ __html: v.description[0] }}
                  ></small>
                  <div className="md:pt-2 lg:mt-3 3xl:mt-4 lg:flex justify-between items-end">
                    <small className="hidden xl:block opacity-40 lg:text-sm">{dateFormat(v.pubDate[0])}</small>
                    <small className="text-main lg:text-sm">{v.category[0]}</small>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <p className="lg:text-2xl my-12 lg:my-8 text-center">
            글을 클릭하시면 실제 현장 사진과 내용을 더 자세히 확인하실 수 있습니다.
          </p>
          {/* CTA buttons */}
          <div className="mt-7 grid lg:grid-cols-2 gap-3 md:mt-10 max-w-[700px] mx-auto">
            <a
              href="/#banner"
              onClick={(e) => {
                if (document.getElementById("banner")) {
                  e.preventDefault();
                  menuOnClick("#banner");
                }
              }}
              className="w-full rounded-full bg-primary pt-2 pb-1 text-center text-sm text-white transition-colors hover:bg-[#e0690f] sm:w-auto md:text-base"
            >
              출장비 없는 출장견적 신청 바로가기
            </a>
            <button
              onClick={openfunc}
              className="w-full rounded-full border-2 border-primary pt-2 pb-1 text-center text-sm text-primary transition-colors hover:bg-orange-50 sm:w-auto md:text-base"
            >
              상세견적문의 바로가기
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog;

const parseString = require("xml2js").parseString;

const ParseData = ({ data }: { data: any[] }) => {
  const dataArr: {
    title: any;
    link: any;
    description: any;
    pubDate: any;
    category: any;
  }[] = [];

  parseString(data, (err: any, result: any) => {
    if (err) {
      console.error("XML 파싱 에러:", err);
      return;
    }

    const items = result?.rss?.channel?.[0]?.item;
    if (Array.isArray(items)) {
      items.slice(0, 9).forEach((v: any) => {
        dataArr.push({
          title: v.title,
          link: v.link,
          description: v.description,
          pubDate: v.pubDate,
          category: v.category,
        });
      });
    } else {
      console.warn("item 배열이 없습니다.");
    }
  });

  return dataArr;
};
